<template>
  <a-layout-header
    class="header-wrap flex-j-b flex-a-c"
    :style="{
      width: isMobile ? '100%' : `calc(100% - ${this.isCollapsed ? 80 : 210}px)`
    }"
  >
    <div class="flex-a-c">
      <img
        v-if="isMobile"
        src="../../assets/logo.png"
        alt="logo"
        width="32"
        height="32"
        style="margin-right:20px;"
      />
      <a-icon
        class="trigger"
        :type="isCollapsed ? 'menu-unfold' : 'menu-fold'"
        @click="toggleCollapsed"
      />
      <breadcrumb></breadcrumb>
    </div>
    <div class="flex-j-b flex-a-c header-menu-wrap">
      <a-tooltip v-if="!isMobile" :title="isScreenfull ? '退出全屏' : '全屏'">
        <a-icon
          :type="isScreenfull ? 'fullscreen-exit' : 'fullscreen'"
          class="bell pointer"
          @click="screenfullClick"
        />
      </a-tooltip>
      <!-- <a-tooltip title="消息">
        <a-icon type="bell" class="bell pointer" />
      </a-tooltip> -->
      <a-dropdown>
        <div class="pointer header-menu flex-a-c">
          <div>
            <a-avatar :src="headImg" />
          </div>
          <div class="name ellipsis">{{ userName }}</div>
        </div>

        <a-menu slot="overlay" @click="handleClick">
          <!-- <a-menu-item key="updatePwd">
            修改密码
          </a-menu-item> -->
          <a-menu-item key="info">
            个人中心
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item key="logout">
            退出登录
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </a-layout-header>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { SET_COLLAPSED, SET_DRAWER } from "@/store/types";
import screenfull from "screenfull";
import Breadcrumb from "@/components/Breadcrumb/Index.vue";
import socket from "@/mixins/socket";
import defaultHeadImg from "@/assets/imgs/default.png";

export default {
  mixins: [socket],
  components: {
    Breadcrumb
  },
  data() {
    return {
      defaultHeadImg,
      isScreenfull: false
    };
  },
  computed: {
    ...mapGetters(["isCollapsed", "isMobile", "isPad", "user"]),
    headImg() {
      if (this.user && this.user.headImg) {
        return this.user.headImg;
      }

      return this.defaultHeadImg;
    },
    userName() {
      if (this.user) {
        return this.user.name;
      }
      return "";
    }
  },
  methods: {
    ...mapMutations({
      setCollapsed: SET_COLLAPSED,
      setDrawer: SET_DRAWER
    }),
    ...mapActions({
      logout: "Logout"
    }),
    toggleCollapsed() {
      if (this.isMobile) {
        this.setDrawer(true);
      } else {
        this.setCollapsed(!this.isCollapsed);
      }
    },
    handleClick({ key }) {
      switch (key) {
        case "info":
          this.$router.push("/adminUserInfo");
          break;
        case "logout":
          this._logout();
          break;
        default:
      }
    },
    screenfullClick() {
      screenfull.toggle().then(() => {
        this.isScreenfull = !this.isScreenfull;
      });
    },
    _logout() {
      const that = this;
      this.$confirm({
        title: "退出",
        content: "确定退出系统吗？",
        okText: "确认",
        cancelText: "取消",
        onOk() {
          that.logout().then(() => {
            that.$router.push({ name: "Login" });
          });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.header-wrap {
  background: #fff;
  padding: 0 24px;
  box-shadow: 0px 1px 4px 0px rgba(0, 21, 41, 0.12);
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  z-index: 999;
  transition: all 0.2s;
  .trigger {
    font-size: 20px;
    padding: 22px 0;
    cursor: pointer;
    transition: color 0.3s;
    &:hover {
      color: @primary-color;
    }
  }
  .header-menu-wrap {
    .bell {
      padding: 22px 8px;
      font-size: 20px;
      transition: background-color 0.3s;
      &:hover {
        background-color: rgba(0, 0, 0, 0.025);
      }
    }
    .header-menu {
      padding: 0 8px;
      transition: background-color 0.3s;
      .name {
        max-width: 60px;
        color: rgba(0, 0, 0, 0.65);
        margin-left: 8px;
      }
      &:hover {
        background-color: rgba(0, 0, 0, 0.025);
      }
    }
  }
}
</style>
